import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

// Helper function to get the appropriate token
const getAccessToken = () => {
  const ftmUserData = localStorage.getItem("ftmUserData");
  const ltmsCompanyData = localStorage.getItem("ltmsCompanyData");

  if (ftmUserData) {
    const user = JSON.parse(ftmUserData);
    return user?.accessToken || "";
  }

  if (ltmsCompanyData) {
    const company = JSON.parse(ltmsCompanyData);
    return company?.accessToken || "";
  }

  return "";
};

// Initialize Axios instance
const api = axios.create({
  baseURL: BASE_URL,
});

// Add request interceptor to dynamically set Authorization header
api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("ftmUserData");
      localStorage.removeItem("ltmsCompanyData");
      localStorage.removeItem("loginToken");
      // Optionally redirect to login.
      window.location.href = "/login";
    }
    return Promise.reject(
      error.response ? error.response.data.message : error.message,
    );
  },
);

// API helper functions
export const get = async (endpoint, params = {}) => {
  try {
    const response = await api.get(endpoint, { params });
    return response.data;
  } catch (error) {
    throw new Error(error.message || "Failed to fetch data");
  }
};

export const post = async (endpoint, data) => {
  try {
    const response = await api.post(endpoint, data);
    return response.data;
  } catch (error) {
    throw new Error(error.message || "Failed to post data");
  }
};

export const put = async (endpoint, data) => {
  try {
    const response = await api.put(endpoint, data);
    return response.data;
  } catch (error) {
    throw new Error(error.message || "Failed to update data");
  }
};

export const deleteApi = async (endpoint) => {
  try {
    const response = await api.delete(endpoint);
    return response.data;
  } catch (error) {
    throw new Error(error.message || "Failed to delete data");
  }
};

export default api;
